import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '../../lib/utils';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'border-silver-primary bg-bg-primary text-text-primary placeholder:text-text-tertiary min-h-[60px] w-full rounded-sm border px-3 py-2 text-sm',
        'focus:border-accent-primary focus:ring-2 focus:ring-[rgba(10,37,64,0.5)] focus:outline-none',
        'resize-y disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
});
